import React from "react";

import PropTypes from "prop-types";
import { Box, Grid } from "@mui/material";

import AuthCard from "./AuthCard";

const AuthWrapperModal = ({ children }) => (
    <Box
        sx={{
            width: '100%',
            height: '100dvh',
            boxSizing: 'border-box',
            overflowY: 'auto',
            overflowX: 'hidden',
            overscrollBehavior: 'contain',
            WebkitOverflowScrolling: 'touch',
            p: { xs: 1, sm: 2 }
        }}
    >
        <Grid
            container
            sx={{
                width: '100%',
                minHeight: '100%',
                m: 0
            }}
            spacing={0}
        >
            <Grid
                item
                xs={12}
                container
                spacing={0}
                justifyContent="center"
                alignItems={{ xs: 'flex-start', sm: 'center' }}
                sx={{
                    minWidth: 0,
                    minHeight: '100%'
                }}
            >
                {/* <Grid item> */}
                <AuthCard>{children}</AuthCard>
                {/* </Grid> */}
            </Grid>
        </Grid>
    </Box>
);

AuthWrapperModal.propTypes = {
    children: PropTypes.node
};

export default AuthWrapperModal;
